<template>
  <aside :class="subdomain">
    <div class="collapse-con" :class="[collapse ? 'collapse': 'expand']">
      <font-awesome-icon v-if="collapse === true" :icon=" ['fas', 'stream']" class="icon" @click="toggleMenuState()"></font-awesome-icon>
      <font-awesome-icon v-else :icon=" ['fas', 'times']" class="icon" @click="toggleMenuState()"></font-awesome-icon>
    </div>
    <nav class="sidemenu">
      <ul v-if="menuRoutes">
        <li :class="[(checkChildren(route.children) && readWrite === 'write') ? 'parent': 'single', (route.name === $route.name) ? 'router-link-exact-active' : '']" v-for="(route, key) in menuRoutes" :key="key">
          <router-link tag="a" :to="{ path: route.path }" :class="[(route.name === $route.name) || (route.name + 'Edit' === $route.name) ? 'router-link-exact-active' : '']">{{route.meta.menuName}} <div class="sidebar--notch sidebar--notch_2" v-if="displayNotchIfChild(route) || $route.name === route.name || route.name + 'Edit' === $route.name"></div><div v-if="route.hasOwnProperty('notification_amount') && admin" class="notification--bubble2">{{route.notification_amount}}</div></router-link>
          <ul v-if="checkChildren(route.children) && readWrite === 'write'" class="children">
            <li class="child" v-for="(child, key) in childrenRoutes(route.children)" :key="key">
              <router-link v-if="child.meta.menuItem" tag="a" :to="{ name: child.name }" tabindex="0"><span class="left-padding">{{child.meta.menuName}}</span> <div class="sidebar--notch sidebar--notch_2" v-if="$route.name === child.name"></div></router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul v-else>
      </ul>
    </nav>
    <small class="copyright ipro">iPro<span class="registeredTrademark">&reg;</span><span class="expand-only"> Systems &copy; </span> {{ new Date().getFullYear() }}</small>
  </aside>
</template>

<script>
import { store } from '@/store/index'
import _ from 'lodash'

export default {
  name: 'sidebarNav',
  data () {
    return {
      globalSearch: '',
      isParent: false,
      collapse: true
    }
  },
  props: [
    'routes',
    'readWrite',
    'subdomain',
    'admin'
  ],
  computed: {
    menuRoutes () {
      if (this.admin) {
        return this.routes.filter(route => {
          return route.meta.menuItem
        }).map(function (route) {
          return route
        })
      } else {
        return this.routes.filter(function (route) {
          if (route.meta.menuItem && !route.meta.adminOnly) {
            if (route.children) {
              route.children = route.children.filter(child => {
                if (child.meta.menuItem) {
                  return child
                } else {
                  return false
                }
              })
              if (route.children.length === 0) {
                delete route.children
              }
              return route
            }
            return route
          }
        }).map(function (route) {
          return route
        })
      }
    },
    group () {
      return store.state.userGroup
    }
  },
  created () {
    this.collapse = JSON.parse(localStorage.getItem('iPro_promo_menustate'))
  },
  methods: {
    toggleMenuState () {
      this.collapse = !this.collapse
      localStorage.setItem('iPro_promo_menustate', this.collapse)
      this.$root.$emit('menuState', this.collapse)
    },
    childrenRoutes (routes) {
      return routes.filter(route => route.meta.menuItem).map(function (route) {
        return route
      })
    },
    checkChildren (routes) {
      return (_.find(routes, function (o) { return o.meta.menuItem === true }))
    },
    displayNotchIfChild (route) {
      let self = this
      if (route.hasOwnProperty('children')) {
        let result = route.children.some(function (child) {
          if (child.path === 'edit') {
            return (self.$route.name === child.name)
          }
        })
        return result
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../less/main.less';

aside{
  height: ~"calc(100vh - 46px)";
  background: #0078A3;
  position: relative;
  box-shadow: -1px 0px 10px @color-menu_secondary;
  z-index: 4;
  &.accounts {
    background: @color-nav;
  }
  &.customers-app {
    background: #8C2D2A;
  }
  &.items-app {
    background: #268028;
  }

}
.sidebar--notch{
  &_1{
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 11.5px 12px 11.5px 0;
    border-color: transparent #fff transparent transparent;
    position: absolute;
    right: 0;
    top: 0;
  }
  &_2{
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7.5px 9px 7.5px 0;
    border-color: transparent #fff transparent transparent;
    position: absolute;
    right: 0;
    top: 6px;
    .accounts & {
      border-color: transparent @color-menu_secondary transparent transparent;
    }
    .items-app & {
      border-color: transparent #fff transparent transparent;
    }
  }
}
nav{
  display: block;
  color: white;
  .font-family();
  font-weight: 600;
  padding-top: 48px;
  li{
    &:first-child{
      margin-top: 0;
    }
    &.single a:after{
      content: '';
      display: block;
      height: 1px;
      background: #fff;
      width: 241px;
      padding-left: 1rem;
      float: right
    }
    &.parent{
      &:after{
        display: none;
      }
      .children{
        background-color: #00AAF0;
        &:before{
          content: '';
          display: block;
          height: 1px;
          background: #00AAF0;
          width: 100%;
          .accounts & {
            background: @color-border;
          }
          .customers-app & {
            background: #BF3E39;
          }
          .items-app & {
            background: #33AB35;
          }
        }
        &:after{
          content: '';
          display: block;
          height: 1px;
          background: #00AAF0;
          width: 100%;
          .accounts & {
            background: @color-border;
          }
          .customers-app & {
            background: #BF3E39;
          }
          .items-app & {
            background: #33AB35;
          }
        }
        .customers-app & {
            background: #BF3E39;
          }
        .items-app & {
          background-color: #33AB35;
        }
      }
      .child{
        a{
          span {
            padding-left: 1rem;
          }
          color: #fff;
          .accounts & {
            color:  @color-menu_secondary;
          }
          .customers-app & {
            background: #BF3E39;
          }
        }
        &:last-child{
          margin-bottom: 0;
        }
        &:after{
          content: '';
          display: block;
          height: 1px;
          background-color: #00AAF0;
          width: calc(241px - 1rem);
          float: right;
          .accounts & {
            background: @color-border;
          }
          .customers-app & {
            background: #BF3E39;
          }
          .items-app & {
            background: #33AB35;
          }
        }
      }
      .router-link-exact-active{
        background-color: darken(#00AAF0, 30%);
        .accounts & {
          background-color: transparent;
        }
        .customers-app & {
          background: darken(#BF3E39, 30%) !important;
        }
        .items-app & {
          background: darken(#33AB35, 30%);
        }

        :before &{
          background: darken(#00AAF0, 30%);
          .accounts & {
            background-color: transparent;
          }
          .customers-app & {
            background: darken(#BF3E39, 30%) !important;
          }
          .items-app & {
            background: darken(#33AB35, 30%);
          }
        }
        :after & {
          background-color: darken(#00AAF0, 30%);
          .accounts & {
            background-color: transparent;
          }
          .customers-app & {
            background: darken(#BF3E39, 30%) !important;
          }
          .items-app & {
            background: darken(#33AB35, 30%);
          }
        }
      }
    }
    .createNew{
      display: none;
      position: absolute;
      left: -22px;
    }
    &:hover{
      .createNew{
        display: inline;
      }
    }
  }
  a{
    padding-left: 1rem;
    text-decoration: none;
    color: white;
    display: block;
    position: relative;
    &.link{
      position: relative;
      left: 130px;
    }
    &:hover{
      text-decoration: none;
      color: @color-header;
    }
    @media @desktop-min {
      padding-left: calc(100px + 1rem);
    }
  }
}
span.registeredTrademark {
  position: relative;
  top: -.3rem;
  font-size: .5rem;
  left: -0.05rem;
}
.notification--bubble1 {
  background-color: @color-highlight;
  color: @color-menu_secondary;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  font-size: .7rem;
  position: absolute;
  top: -16px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid;
  box-sizing: border-box;
}
.notification--bubble2 {
  background-color: @color-highlight;
  color: @color-menu_secondary;
  border-radius: 100%;
  min-width: 23px;
  height: 23px;
  font-size: 0.7rem;
  position: absolute;
  top: -17px;
  right: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid @color-menu_secondary;
  box-sizing: content-box;
  box-shadow: 0 0 0 3px @color-nav;
  .items-app & {
    box-shadow: 0 0 0 3px #268028;
  }
}
.collapse-con {
  width: 100%;
  display: flex;
  .icon {
    color: #fff;
    padding: 5px;
    height: 30px;
    width: 30px;
    margin-top: .5rem;
  }
  &.expand {
    justify-content: flex-end;
    padding-right: 15px;
  }
  &.collapse {
    justify-content: center;
  }
}
.collapse_menu {
  .copyright{
    right: 0 !important;
    left: 4px !important;
  }
  .expand-only {
    display: none;
  }
}
.copyright {
  color: #fff;
}
.router-link-exact-active{
  background-color: darken(#00AAF0, 30%);
  .accounts & {
    background-color: transparent;
  }
  .customers-app & {
      background: darken(#BF3E39, 30%) !important;
    }
  .items-app & {
    background: darken(#33AB35, 30%);
  }
  :before &{
    background: darken(#00AAF0, 30%);
    .accounts & {
      background-color: transparent;
    }
    .customers-app & {
      background: darken(#BF3E39, 30%) !important;
    }
    .items-app & {
      background: darken(#33AB35, 30%);
    }
  }
  &:after{
    background: darken(#00AAF0, 30%) !important;
    display: none !important;
    .accounts & {
      display: block !important;
      background-color: #fff !important;
    }
    .customers-app & {
      background: darken(#BF3E39, 30%) !important;
    }
    .items-app & {
      background: darken(#33AB35, 30%);
    }
  }
  &:hover {
    color: darken(#ffffff, 15%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foundation/sidebarNav.vue